<app-navbar></app-navbar>
<div class="container">
  <router-outlet></router-outlet>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/main/main.component.html